import { css } from 'styled-components';

/** @class ChipLabelMixin */
/** @method */
export var ChipLabelMixin = /*#__PURE__*/css(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"]);